<script setup lang="ts">
import { useTeamStore, useUserStore } from '@blueprint/frontend-basics'
import { computed, onMounted, ref } from 'vue'
import { useRoute, useRouter } from 'vue-router'

import ShopOnlineUsers from '@/components/organisms/ShopOnlineUsers.vue'
import { useServiceStore } from '@/stores/service.store.ts'

const route = useRoute()
const router = useRouter()
const teamStore = useTeamStore()
const userStore = useUserStore()
const serviceStore = useServiceStore()

const loading = ref(true)
const shopId = computed(() => route.params.shopId as string)
const teamId = computed(() => route.params.teamId as string)

onMounted(async () => {
  loading.value = true
  await userStore.awaitInit()

  if (userStore.isAnonymous) {
    try {
      const resolved = router.resolve({
        name: route.name as string,
        params: route.params,
        query: route.query,
      })
      const redirectUrl = new URL(resolved.href, window.location.origin).toString()
      await serviceStore.authService.startLoginProcess(redirectUrl)
    } catch (error) {
      console.error('Login redirect failed:', error)
    }
    loading.value = false
    return
  }

  if (teamId.value) {
    if (teamStore.teamsAvailable.length === 0) {
      await teamStore.loadTeams(serviceStore, 0)
    }
    const team = teamStore.teamsAvailable.find((t) => t.id === teamId.value)
    if (team) {
      await teamStore.selectTeam(serviceStore, team)
    }
  }

  loading.value = false
})
</script>

<template>
  <v-container max-width="720" class="py-6">
    <v-progress-linear v-if="loading" indeterminate color="primary" class="mb-4" />
    <ShopOnlineUsers v-else-if="shopId" :shop-id="shopId" />
  </v-container>
</template>
